import gql from "graphql-tag";

export default gql`
	query countCashManager($attributes: FilterCashManagerInput) {
		countCashManager(attributes: $attributes)
	}
`;
